<div class="faqs-questions">
    <div class="faqs-header">
        <div class="icon-wrapper">
            <i data-feather="help-circle"></i>
        </div>
        <h2 class="title">Preguntas más frecuentes</h2>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="16px">
        <div fxFlex="50%">
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        ¿Cuáles son las formas de pago?
                    </mat-expansion-panel-header>

                    <ul>
                        <li>Tarjeta de Débito o Crédito (Mutualcard - Cabal - Visa - Mastercad)</li>
                        <li>Transferencia Bancaria</li>
                        <li>Efectivo en domicilio (Sólo Venado Tuerto, Santa Isabel y Chovet)</li>
                    </ul>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        Mi producto esta defectuoso ¿Qué hago?
                    </mat-expansion-panel-header>

                    <p>
                        Ante cualquier falla o desperfecto técnico, Plaza Hogar ofrece 10 días corridos para realizar el cambio del producto por uno nuevo.<br>

                        Pasado ese período, el cliente tendrá que dirigirse  al Service Oficial de la marca. Comunicándote con Plaza Hogar, te informaremos los datos del mismo y te indicaremos pasos a seguir. <br>

                        Todos los productos cuentan con garantía oficial de fabrica  (por desperfectos de fabricación), salvo que quede expresado de otra manera.
                    </p>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div fxFlex="50%">
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        ¿Se pueden hacer devoluciones?
                    </mat-expansion-panel-header>

                    <p>La devolución de productos se acepta dentro de los DIEZ (10) días corridos a partir de la fecha de recibida la mercadería, absorbiendo el cliente el costo del envío. Los cambios se encuentran sujetos a disponibilidad de stock. Será necesario que el producto esté en perfectas condiciones, con etiquetas, accesorios y empaques originales (incluyendo manuales, guías de uso, certificados de garantía, etc.). En todos los casos se deberá conservar la factura de compra.</p>


                    <p>El Usuario puede gestionar la devolución de la compra dentro de los 10 días de corrido de recibido el producto, cuando:</p>
                    <ul>
                        <li>El producto no corresponde al detalle de la factura.</li>
                        <li>El producto corresponde al detalle de la factura, pero no es lo solicitado en la orden de compra.</li>
                        <li>El producto entregado se encuentra con fallas en su funcionamiento.</li>
                    </ul>

                    <p>Debido a la naturaleza de algunos artículos, no aceptamos devoluciones en todos los productos:</p>
                    <ul>
                        <li>Productos considerados frágiles, (artículos de vidrio, espejos, entre otros)</li>
                        <li>Productos de uso personal. (depiladoras, afeitadoras, etc)</li>
                        <li>Licencias o productos virtuales.</li>
                        <li>Productos que requieren instalación y ya han sido instalados para su uso (calefactores, aires acondicionados, calefones, termotanques, anafes, cocinas, campanas, lavarropas, lavasecarropas, lavavajillas, heladeras, freezers, cavas y exhibidoras, una vez instalados no tienen devolución). En caso de tener alguna falla de funcionamiento, comunicarse con nuestro servicio Post Venta</li>
                    </ul>

                    <p>Al momento de recibir el producto, recomendamos chequear el estado del mismo. Una vez firmado el remito en conformidad, se considerará la entrega en buen estado.</p>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        ¿Llegan envíos a mi localidad?
                    </mat-expansion-panel-header>

                    <p>Plaza Hogar cuenta con un Centro de Distribución propio</p>
                    <p><strong></strong></p>
                    <ul>
                        <li>El cliente podrá retirar el/los productos SIN CARGO por nuestra sucursal.</li>
                        <li>El envío a domicilio dentro de la ciudad de Venado Tuerto tiene un costo de $7500.</li>
                    </ul>

                    <p><strong>Santa Isabel y Chovet</strong></p>
                    <ul>
                        <li>El cliente podrá retirar el/los productos SIN CARGO por nuestra sucursal.</li>
                        <li>Para envíos a domicilio dentro de Santa Isabel o Chovet, el cliente deberá comunicarse con nosotros al (03462) 427715 - 421821 para obtener información sobre costos adicionales</li>
                    </ul>

                    <p><strong>Otros puntos del país:</strong></p>
                    <ul>
                        <li>El costo de envío podrás calcularlo en el proceso de compra. Te enviaremos un código de seguimiento, para que puedas hacer el seguimiento online de tu compra.</li>
                    </ul>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
